export default __webpack_public_path__ + "static/media/picinterior.2ef40efe.jpg";